<template>
  <div class="halababy_page">
    <div
      class="hp_1 geli"
      :style="{ backgroundImage: 'url(' + imgSiteNum0 + ')' }"
    >
      <img class="hp_1_1" :src="imgSiteNum1" />
      <p class="hp_1_2" v-html="testList[0]"></p>
      <div class="halababy_1">
        <p class="hp_1_3" v-html="testList[1]">
        </p>
        <a class="hp_1_4" :href="appUrl" >
          {{ testList[29] }}
        </a>
      </div>
    </div>
    <div class="hp_2 geli">
      <moduleTitle2 :title="testList[2]" :description="testList[3]"></moduleTitle2>
      <div
        class="hp_21"
        :style="{ backgroundImage: 'url(' + imgSiteNum2 + ')' }"
      >
        <p class="hp_2_3">{{ testList[4] }}</p>
        <p class="hp_2_4">
          {{ testList[5] }}
        </p>
        <p class="hp_2_5">{{ testList[6] }}</p>
        <p class="hp_2_6">
          {{ testList[7] }}
        </p>
      </div>
    </div>
    <div class="hp_3 geli">
      <moduleTitle2 :title="testList[8]" :description="testList[9]"></moduleTitle2>
      <div class="hp_3_3">
        <div
          class="hp_3_31"
          :style="{ backgroundImage: 'url(' + imgSiteNum3 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[10] }}</p>
        </div>
        <div
          class="hp_3_32"
          :style="{ backgroundImage: 'url(' + imgSiteNum4 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[11] }}</p>
        </div>
        <div
          class="hp_3_33"
          :style="{ backgroundImage: 'url(' + imgSiteNum5 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[12] }}</p>
        </div>
        <div
          class="hp_3_34"
          :style="{ backgroundImage: 'url(' + imgSiteNum6 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[13] }}</p>
        </div>
        <div
          class="hp_3_35"
          :style="{ backgroundImage: 'url(' + imgSiteNum7 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[14] }}</p>
        </div>
        <div
          class="hp_3_36"
          :style="{ backgroundImage: 'url(' + imgSiteNum8 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[15] }}</p>
        </div>
        <div
          class="hp_3_37"
          :style="{ backgroundImage: 'url(' + imgSiteNum9 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[16] }}</p>
        </div>
        <div
          class="hp_3_38"
          :style="{ backgroundImage: 'url(' + imgSiteNum10 + ')' }"
        >
          <p class="hp_3_317 hp33p">{{ testList[17] }}</p>
        </div>
        <div
          class="hp_3_39"
          :style="{ backgroundImage: 'url(' + imgSiteNum11 + ')' }"
        >
          <p class="hp_3_318 hp33p">{{ testList[18] }}</p>
        </div>
      </div>
    </div>
    <div class="hp_4 geli">
      <moduleTitle2 :title="testList[19]" :description="testList[20]"></moduleTitle2>
      <div class="hp_4_3" id="roll">
        <ul class="wrap">
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala17.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala18.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala19.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala20.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala21.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala23.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala24.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala25.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala26.jpg" />
            </div>
          </li>
        </ul>
        <ul class="wrap2">
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala17.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala18.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala19.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala20.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala21.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala23.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala24.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala25.jpg" />
            </div>
          </li>
          <li>
            <div class="rolld">
              <img width="360px" height="360px" src="../assets/hala/hala26.jpg" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="hp_5 geli">
      <moduleTitle2 :title="testList[21]" :description="testList[22]"></moduleTitle2>
      <div class="hp_5_3">
        <div class="hp_5_31">
          <div class="hp_5_311">
            <p>{{ testList[23] }}</p>
            <div
              class="hp_5_311di halababay_hala1"
              style="
                background-image: url('../assets/hala/hala30.jpg'),
              "
            ></div>
          </div>
          <div class="hp_5_311">
            <p>{{ testList[24] }}</p>
            <div
              class="hp_5_311di halababay_hala2"
              style="
                background-image: url('../assets/hala/hala27.jpg'),
              "
            ></div>
          </div>
        </div>
        <div class="hp_5_31">
          <div class="hp_5_312">
            <div
              class="hp_5_311di halababay_hala3"
              style="
                background-image: url('../assets/hala/hala28.jpg'),
              "
            ></div>
            <p>{{ testList[25] }}</p>
          </div>
          <div class="hp_5_312">
            <div
              class="hp_5_311di halababay_hala4"
              style="
                background-image: url('../assets/hala/hala29.jpg'),
              "
            ></div>
            <p>{{ testList[26] }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="hp_6 geli">
      <moduleTitle2 :title="testList[27]" :description="testList[28]"></moduleTitle2>
      <div
        class="hp_6_3"
        :style="{
          background: 'url(' + imgSiteNum20 + ') no-repeat center center',
        }"
      >
        <div class="hp_6_3zz" id="hp_6_3zz">
          <div
            v-for="(item, index) in books"
            :key="index"
            :class="'hp_6_3zz' + (index + 1)"
          >
            <div class="hp_6_31">
              <div v-for="(it, ind) in item" :key="ind">
                <div v-if="ind <= 3" class="hp631">
                  <div class="hp6311">
                    <div
                      class="hp63111"
                      :style="{
                        background:
                          'url(' + ip + it.icon + ') no-repeat center center',
                      }"
                    ></div>
                    <p class="hp63112">{{ it.name }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="hp_6_32">
              <div v-for="(it, ind) in item" :key="ind">
                <div v-if="ind > 3" class="hp631">
                  <div class="hp6311">
                    <div
                      class="hp63111"
                      :style="{
                        background:
                          'url(' + ip + it.icon + ') no-repeat center center',
                      }"
                    ></div>
                    <p class="hp63112">{{ it.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hp_6_3z2">
          <div class="hp_6_3z21" id="hp_6_3z21">
            <div
              ref="sesss"
              v-for="(item, index) in books"
              :key="index"
              class="hp63z21"
            >
              <div ref="section" class="hp63z211"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleTitle2 from "./component/moduleTitle2.vue";

export default {
  name: "halababy_page",
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.changeLang(type);
    },
  },
  components: {
    moduleTitle2,
  },
  created: function () {
    //设置"科学启蒙"模块轮播数据
    this.currentIndex = 0;

    //获取文案
    // this.changeLang(this.$i18n.locale);
    // //从后台获取数据
    // this.getImg();
    // this.getBook();
    // this.getHalababy();
  },
  mounted: function () {

    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.changeLang('zh')
    }else{
      this.changeLang('en')
    }

    this.getImg();
    this.getBook();
    this.getHalababy();

    //儿童模块
    var oDiv = document.getElementById("roll");
    var wraps = oDiv.getElementsByTagName("ul");
    var wrap = wraps[0];
    var wrap2 = wraps[1];
    var iSpeed = -2;
    var timer = null;
    //设置定时长执行
    timer = setInterval(function () {
      wrap.style.left = wrap.offsetLeft + iSpeed + "px";
      wrap2.style.left = wrap2.offsetLeft + iSpeed + "px";
      //当-left >= width
      if (-wrap.offsetLeft >= wrap.offsetWidth) {
        wrap.style.left = "1920px";
      }
      if (-wrap2.offsetLeft >= wrap2.offsetWidth) {
        wrap2.style.left = "1920px";
      }
    }, 30);

    oDiv.onmouseover = function () {
      clearInterval(timer);
    };
    oDiv.onmouseout = function () {
      timer = setInterval(function () {
        wrap.style.left = wrap.offsetLeft + iSpeed + "px";
        wrap2.style.left = wrap2.offsetLeft + iSpeed + "px";
        //当left >= width
        if (-wrap.offsetLeft >= wrap.offsetWidth) {
          wrap.style.left = "1920px";
        }
        if (-wrap2.offsetLeft >= wrap2.offsetWidth) {
          wrap2.style.left = "1920px";
        }
      }, 30);
    };
  },
  updated() {},
  destroyed(){
    clearInterval(this.bookRolInterval);
  },
  methods: {
    bookRoll() {
      let selects = document.getElementsByClassName("hp63z211");
      selects[this.currentIndex].style.backgroundColor = "#f68104";
      this.bookRolInterval = setInterval(() => {
        //获取元素
        let blocks = document.getElementById("hp_6_3zz").children;
        let selects = document.getElementsByClassName("hp63z211");
        let index = this.currentIndex;
        for (let i = 0; i < blocks.length; i++) {
          blocks[index].className = "hp_6_3zzhbb" + (i + 1);
          index += 1;
          if (index == blocks.length) {
            index = 0;
          }
          selects[index].style.backgroundColor = "rgba(255, 255, 255, 0.6)";
        }
        this.currentIndex += 1;
        if (this.currentIndex == blocks.length) {
          this.currentIndex = 0;
        }
        selects[this.currentIndex].style.backgroundColor = "#f68104";
      }, 4000);
    },
    getHalababy(){
      this.$post("/halababy/loofox/gethalababy").then((res) => {
        this.appUrl = res.data;
      });
    },
    getBook() {
      this.$post("/halababy/loofox/book", { num: 28 }).then((res) => {
        this.books = res.data;
        this.$nextTick(() => {
          this.bookRoll();
        });
      });
    },
    getImg() {
      this.$post("/halababy/loofox/img", { pageNum: 2 }).then((res) => {
        this.imgSiteNum0 = this.$ip + res.data[0]["imgUrl"];
        this.imgSiteNum1 = this.$ip + res.data[1]["imgUrl"];
        this.imgSiteNum2 = this.$ip + res.data[2]["imgUrl"];
        this.imgSiteNum3 = this.$ip + res.data[3]["imgUrl"];
        this.imgSiteNum4 = this.$ip + res.data[4]["imgUrl"];
        this.imgSiteNum5 = this.$ip + res.data[5]["imgUrl"];
        this.imgSiteNum6 = this.$ip + res.data[6]["imgUrl"];
        this.imgSiteNum7 = this.$ip + res.data[7]["imgUrl"];
        this.imgSiteNum8 = this.$ip + res.data[8]["imgUrl"];
        this.imgSiteNum9 = this.$ip + res.data[9]["imgUrl"];
        this.imgSiteNum10 = this.$ip + res.data[10]["imgUrl"];
        this.imgSiteNum11 = this.$ip + res.data[11]["imgUrl"];
        this.imgSiteNum12 = this.$ip + res.data[12]["imgUrl"];
        this.imgSiteNum13 = this.$ip + res.data[13]["imgUrl"];
        this.imgSiteNum14 = this.$ip + res.data[14]["imgUrl"];
        this.imgSiteNum15 = this.$ip + res.data[15]["imgUrl"];
        this.imgSiteNum16 = this.$ip + res.data[16]["imgUrl"];
        this.imgSiteNum17 = this.$ip + res.data[17]["imgUrl"];
        this.imgSiteNum18 = this.$ip + res.data[18]["imgUrl"];
        this.imgSiteNum19 = this.$ip + res.data[19]["imgUrl"];
        this.imgSiteNum20 = this.$ip + res.data[20]["imgUrl"];
      });
    },
    //修改语言
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 2 }).then((res) => {
        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
      });
    },
  },
  data() {
    return {
      appUrl: '',
      books: this.books,
      ip: this.$ip,
      testList:[],
      imgSiteNum0: this.imgSiteNum0,
      imgSiteNum1: this.imgSiteNum1,
      imgSiteNum2: this.imgSiteNum2,
      imgSiteNum3: this.imgSiteNum3,
      imgSiteNum4: this.imgSiteNum4,
      imgSiteNum5: this.imgSiteNum5,
      imgSiteNum6: this.imgSiteNum6,
      imgSiteNum7: this.imgSiteNum7,
      imgSiteNum8: this.imgSiteNum8,
      imgSiteNum9: this.imgSiteNum9,
      imgSiteNum10: this.imgSiteNum10,
      imgSiteNum11: this.imgSiteNum11,
      imgSiteNum12: this.imgSiteNum12,
      imgSiteNum13: this.imgSiteNum13,
      imgSiteNum14: this.imgSiteNum14,
      imgSiteNum15: this.imgSiteNum15,
      imgSiteNum16: this.imgSiteNum16,
      imgSiteNum17: this.imgSiteNum17,
      imgSiteNum18: this.imgSiteNum18,
      imgSiteNum19: this.imgSiteNum19,
      imgSiteNum20: this.imgSiteNum20,
      imgSiteNum21: this.imgSiteNum21,
    };
  },
};
</script>

<style>
.halababy_page {
  width: 100%;
}
.geli {
  margin: 0 auto 60px auto;
}
.hp_title {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
}
.hp_desc {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  margin: 30px auto 30px auto;
}
.hp_1 {
  width: 100%;
  height: 600px;
  position: relative;
}
.hp_1 .hp_1_1 {
  position: absolute;
  top: 87px;
  left: 420px;
}
.hp_1 .hp_1_2 {
  position: absolute;
  top: 184px;
  left: 420px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 32px;
}
.hp_1_3 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 30px;
  text-align: left;
}
.hp_1_4 {
  text-decoration: none;
  display: inline-block;
  margin-top: 40px;
  padding: 15px 50px;
  /* height: 54px; */
  background-color: #ffffff;
  border-radius: 27px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0ab1ff;
  border: none;
  cursor: pointer;
}
.hp_2 {
  width: 1200px;
}
.hp_21 {
  width: 1106px;
  height: 562px;
  margin: auto;
  position: relative;
}
.hp_2 .hp_2_3 {
  position: absolute;
  top: 319px;
  left: 67px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}

.hp_2 .hp_2_4 {
  position: absolute;
  top: 366px;
  left: 67px;
  width: 448px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 30px;
  text-align: left;
}
.hp_2 .hp_2_5 {
  position: absolute;
  top: 319px;
  left: 590px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.hp_2 .hp_2_6 {
  position: absolute;
  top: 366px;
  left: 590px;
  width: 448px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 30px;
  text-align: left;
}
.hp_3 {
  width: 1200px;
}
.hp_3 .hp_3_3 {
  width: 100%;
  height: 670px;
  position: relative;
}
.hp33p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0ab1ff;
}
.hp_3 .hp_3_3 .hp_3_31 {
  position: absolute;
  left: 546px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_32 {
  position: absolute;
  left: 756px;
  top: 108px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_33 {
  position: absolute;
  left: 864px;
  top: 278px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_34 {
  position: absolute;
  left: 756px;
  top: 448px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_35 {
  position: absolute;
  left: 546px;
  top: 556px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_36 {
  position: absolute;
  left: 336px;
  top: 448px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_37 {
  position: absolute;
  left: 228px;
  top: 278px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_38 {
  position: absolute;
  left: 336px;
  top: 108px;
  width: 108px;
  height: 108px;
}
.hp_3 .hp_3_3 .hp_3_39 {
  position: absolute;
  left: 496px;
  top: 210px;
  width: 208px;
  height: 208px;
}
.hp_3_3 div:hover {
  -webkit-transform: scale(1.2, 1.2);
  -moz-transform: scale(1.2, 1.2);
  -transform: scale(1.2, 1.2);
  z-index: 9999;
}
.hp_3 .hp_3_3 .hp_3_310 {
  position: absolute;
  left: 570px;
  top: 74px;
  width: 108px;
  height: 108px;
  background-image: url("../assets/hala/hala4.png");
}
.hp_3_317 {
  margin-top: 70px;
}
.hp_3_318 {
  margin-top: 160px;
}
.hp_4 {
  width: 100%;
}
.hp_4_3 {
  width: 100%;
  height: 475px;
  overflow: hidden;
  position: relative;
  margin: auto;
}
.wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 475px;
}
.wrap2 {
  position: absolute;
  top: 0;
  left: 1920px;
  width: 1920px;
  height: 475px;
}
.rolld {
  width: 380px;
  height: 380px;
  background-image: url("../assets/hala/hala22.png");
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.hp_4_3 ul li {
  float: left;
  list-style: none;
  width: 384px;
  height: 475px;
}

.hp_4_31 {
  width: 360px;
  height: 450px;
  float: left;
}
.hp_4_311 {
  width: 288px;
  margin: 10px auto 0 auto;
  text-align: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 30px;
}
.hp_5 {
  width: 1200px;
}
.hp_5_3 {
  width: 1200px;
}
.hp_5_31 {
  display: flex;
  margin-top: 10px;
  justify-content: space-evenly;
}
.hp_5_311,
.hp_5_312 {
  border-radius: 25px;
  background-color: rgba(48, 155, 255, 1);
}
.hp_5_311 p,
.hp_5_312 p {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin: 25px auto;
}
.hp_5_311di {
  width: 584px;
  height: 328px;
  background-size: 100%;
  background-position: center center;
  border-radius: 20px;
  transition: all 0.6s;
}
.hp_5_311:hover .hp_5_311di,
.hp_5_312:hover .hp_5_311di {
  /* background-size: 120% !important; */
  background-size: 110%;
  /* animation: ani1 2s ease 0s 1 alternate forwards;
  -webkit-animation: ani1 2s ease 0s 1 alternate forwards; */
}


.hp_6 {
  width: 1200px;
}
.hp_6_3 {
  width: 1026px;
  height: 585px;
  margin: auto;
  background: url("../assets/hala/hala13.png") no-repeat;
}
.hp_6_3zz {
  width: 880px;
  height: 460px;
  margin: auto;
  position: relative;
  overflow: hidden;
}
.hp_6_3zz1 {
  position: absolute;
  top: 125px;
  left: 108px;
}
.hp_6_3zz2 {
  position: absolute;
  top: 125px;
  left: 1634px;
}
.hp_6_3zz3 {
  position: absolute;
  top: 125px;
  left: 2242px;
}
.hp_6_3zz4 {
  position: absolute;
  top: 125px;
  left: 2850px;
}
.hp_6_31 {
  width: 664px;
  height: 144px;
  display: flex;
  justify-content: start;
}
.hp631 {
  width: 166px;
  height: 144px;
  overflow: hidden;
}

.hp6311 {
  padding-top: 10px;

  margin: auto;
  width: 136px;
  height: 144px;
  background-image: url("../assets/hala/hala15.png");
}
.hp63111,
.hp63211 {
  width: 106px;
  height: 98px;
  overflow: hidden;
  margin: auto;
  background: url("../assets/04.png") no-repeat center center;
  border-radius: 10px;
}
.hp63111:hover,
.hp63211:hover {
  background-size: 300% !important;
}
.hp63112{
  margin: auto;
  width: 106px;
  overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.hp_6_31 div p,
.hp_6_32 div p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.hp_6_32 {
  width: 498px;
  display: flex;
  margin: 40px auto 0 auto;
  justify-content: start;
}

.hp_6_3z2 {
  width: 100%;
  height: 30px;
  top: 455px;
  display: flex;
  justify-content: center;
}
.hp_6_3z21 {
  margin: auto;
  height: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}
.hp63z21 {
  width: 56px;
}
.hp63z21 div {
  width: 36px;
  height: 6px;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.6);
}
/* rgba(ff,ff,ff,0.6) */
.hp_6_3zzhbb1 {
  width: 694px;
  height: 450px;
  position: absolute;
  overflow: hidden;
  top: 125px;
  left: 108px;
  animation: hbb1 3s ease 0s 1 alternate forwards;
  -webkit-animation: hbb1 3s ease 0s 1 alternate forwards;
}
.hp_6_3zzhbb2 {
  width: 694px;
  height: 450px;
  position: absolute;
  overflow: hidden;
  top: 125px;
  left: 880px;
  animation: hbb2 3s ease 0s 1 alternate forwards;
  -webkit-animation: hbb2 3s ease 0s 1 alternate forwards;
}
.hp_6_3zzhbb3 {
  width: 694px;
  height: 450px;
  position: absolute;
  overflow: hidden;
  top: 125px;
  left: 1760px;
  animation: hbb3 3s ease 0s 1 alternate forwards;
  -webkit-animation: hbb3 3s ease 0s 1 alternate forwards;
}
.hp_6_3zzhbb4 {
  width: 694px;
  height: 450px;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 2640px;
  animation: hbb4 3s ease 0s 1 alternate forwards;
  -webkit-animation: hbb4 3s ease 0s 1 alternate forwards;
}
.hp_6_3zzhbb5 {
  width: 694px;
  height: 450px;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 3520px;
  animation: move 3s ease 0s 1 alternate forwards;
  -webkit-animation: move 3s ease 0s 1 alternate forwards;
}

/* 设置动画 */
@keyframes hbb1 {
  from {
    left: 108px;
  }
  to {
    left: -880px;
  }
}
@-webkit-keyframes hbb1 {
  from {
    left: 108px;
  }
  to {
    left: -880px;
  }
}
@-ms-keyframes hbb1 {
  from {
    left: 108px;
  }
  to {
    left: -880px;
  }
}

@keyframes hbb2 {
  from {
    left: 880px;
  }
  to {
    left: 108px;
  }
}
@-webkit-keyframes hbb2 {
  from {
    left: 880px;
  }
  to {
    left: 108px;
  }
}
@-ms-keyframes hbb2 {
  from {
    left: 880px;
  }
  to {
    left: 108px;
  }
}

@keyframes hbb3 {
  from {
    left: 1760px;
  }
  to {
    left: 880px;
  }
}
@-webkit-keyframes hbb3 {
  from {
    left: 1760px;
  }
  to {
    left: 880px;
  }
}
@-ms-keyframes hbb3 {
  from {
    left: 1760px;
  }
  to {
    left: 880px;
  }
}

@keyframes hbb4 {
  from {
    left: 2640px;
  }
  to {
    left: 1760px;
  }
}
@-webkit-keyframes hbb4 {
  from {
    left: 2640px;
  }
  to {
    left: 1760px;
  }
}
@-ms-keyframes hbb4 {
  from {
    left: 2640px;
  }
  to {
    left: 1760px;
  }
}

@keyframes hbb5 {
  from {
    left: 3520px;
  }
  to {
    left: 2640px;
  }
}
@-webkit-keyframes hbb5 {
  from {
    left: 3520px;
  }
  to {
    left: 2640px;
  }
}
@-ms-keyframes hbb5 {
  from {
    left: 3520px;
  }
  to {
    left: 2640px;
  }
}

.halababy_1{
  position: absolute;
  top: 254px;
  left: 420px;
  text-align: left;
}
.halababay_hala1{
  background-image: url("../assets/hala/hala28.jpg");
  background-size: 100%;
  background-position: center center;
}
.halababay_hala2{
  background-image: url("../assets/hala/hala30.jpg");
  background-size: 100%;
  background-position: center center;
}
.halababay_hala3{
  background-image: url("../assets/hala/hala27.jpg");
  background-size: 100%;
  background-position: center center;
}
.halababay_hala4{
  background-image: url("../assets/hala/hala29.jpg");
  background-size: 100%;
  background-position: center center;
}

</style>



// WEBPACK FOOTER //
// src/components/halababy.vue